var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFinanceOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24995 4.65505C1.55858 4.65505 0.916879 4.86766 0.386642 5.23105C0.601763 4.47319 1.22245 3.85904 2.04777 3.69173L13.8761 1.29379C15.0534 1.05512 16.2013 1.81601 16.4399 2.99328L16.8122 4.82975C16.4789 4.71649 16.1216 4.65505 15.7499 4.65505H15.3994L15.1168 3.26151C15.0263 2.81496 14.5909 2.52634 14.1444 2.61687L4.09059 4.65505H2.24995ZM0.0749512 7.95503C0.0749512 6.75381 1.04873 5.78003 2.24995 5.78003H15.7499C16.9512 5.78003 17.9249 6.75381 17.9249 7.95503V15.455C17.9249 16.6562 16.9512 17.63 15.7499 17.63H2.24995C1.04873 17.63 0.0749512 16.6562 0.0749512 15.455V7.95503ZM2.24995 7.13003C1.79432 7.13003 1.42495 7.49939 1.42495 7.95503V9.85957L4.15449 7.13003H2.24995ZM5.74548 7.13003L1.42495 11.4506V11.9595L5.74544 16.28H12.2545L16.5749 11.9596V11.4505L12.2544 7.13003H5.74548ZM13.8454 7.13003L16.5749 9.85953V7.95503C16.5749 7.49939 16.2056 7.13003 15.7499 7.13003H13.8454ZM15.7499 16.28H13.8455L16.5749 13.5506V15.455C16.5749 15.9107 16.2056 16.28 15.7499 16.28ZM1.42495 15.455V13.5505L4.15445 16.28H2.24995C1.79432 16.28 1.42495 15.9107 1.42495 15.455ZM8.99995 10.13C8.1301 10.13 7.42495 10.8352 7.42495 11.705C7.42495 12.5749 8.1301 13.28 8.99995 13.28C9.86979 13.28 10.5749 12.5749 10.5749 11.705C10.5749 10.8352 9.86979 10.13 8.99995 10.13ZM6.07495 11.705C6.07495 10.0896 7.38451 8.78003 8.99995 8.78003C10.6154 8.78003 11.9249 10.0896 11.9249 11.705C11.9249 13.3205 10.6154 14.63 8.99995 14.63C7.38451 14.63 6.07495 13.3205 6.07495 11.705Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceOutlined);
export default __webpack_public_path__ + "static/media/financeOutlined.5624c6078c1bbe238cf2cd23d841e453.svg";
export { ForwardRef as ReactComponent };